import React from 'react';

const StartPage = () => {
  return (
    <div className="fixed inset-0 z-50 flex flex-col w-full h-full items-center justify-center bg-slate-100">
      <div className="text-center px-6">
        <h1 className="text-4xl font-bold mb-8 text-slate-800">Welcome</h1>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            href="/en"
            className="px-6 py-3 text-lg font-semibold text-white bg-blue-600 hover:bg-blue-700 rounded-lg shadow-sm transition duration-200"
          >
            English
          </a>
          <a
            href="/ru"
            className="px-6 py-3 text-lg font-semibold text-white bg-blue-600 hover:bg-blue-700 rounded-lg shadow-sm transition duration-200"
          >
            Русский
          </a>
        </div>
      </div>
    </div>
  );
};

export default StartPage;
